import { render, staticRenderFns } from "./UserManagementTabs.vue?vue&type=template&id=0a27d1bc&scoped=true&"
import script from "./UserManagementTabs.vue?vue&type=script&lang=js&"
export * from "./UserManagementTabs.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementTabs.vue?vue&type=style&index=0&id=0a27d1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27d1bc",
  null
  
)

export default component.exports